export class AppService {
  static initialize() {
    
    return {};
  }
}
